export const usePopUpSearch = {
  data () {
    return {
      searchData: '',
      searchWasApplied: false,
    }
  },
  methods: {
    startSearch() {
      if (this.choosedFields) {
        this.choosedFields = [];
      }
      this.searchWasApplied = true
      this.$emit('search', 1, this.searchData)
    },
    dropSearch() {
      if (this.choosedFields) {
        this.choosedFields = [];
      }
      this.searchWasApplied = false
      this.searchData = ''
      this.$emit('search', 1, [])
    },
    changePage(value) {
      if (this.choosedFields) {
        this.choosedFields = []
      }
      const usingData = this.searchWasApplied ? this.searchData : []
      this.$emit('search', value, usingData)
    },
    resetSearchForm() {
      this.searchData = ''
      this.searchWasApplied = false
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/usePopUpSearch.js